import { Component, Output, EventEmitter, Input } from "@angular/core";

@Component({
  selector: "filter-buttons",
  templateUrl: "./filter-buttons.component.html",
  styleUrls: ["./filter-buttons.component.css"],
})
export class FilterButtonsComponent {
  @Output() search = new EventEmitter<void>();
  @Output() addFilter = new EventEmitter<void>();
  @Output() clearFilters = new EventEmitter<void>();
  @Input() showFilterPalette: boolean = true;

  onSearch() {
    this.search.emit();
  }

  onAddFilter() {
    this.addFilter.emit();
  }

  onClearFilters() {
    this.clearFilters.emit();
  }
}
